const VERSION_NUMBER_REGEX = /\d+/g;

const parseVersion = (version: string, maxParts?: number): number[] => {
  const parts = version.match(VERSION_NUMBER_REGEX)?.map(Number) ?? [];

  return typeof maxParts === 'number' ? parts.slice(0, maxParts) : parts;
};

const compareVersions = (
  currentVersion: string,
  targetVersion: string,
  maxParts?: number,
): number => {
  const currentParts = parseVersion(currentVersion, maxParts);
  const targetParts = parseVersion(targetVersion, maxParts);

  for (
    let i = 0;
    i < Math.max(currentParts.length, targetParts.length);
    i++
  ) {
    const current = currentParts[i] ?? 0;
    const target = targetParts[i] ?? 0;

    if (current < target) {
      return -1;
    }

    if (current > target) {
      return 1;
    }
  }

  return 0;
};

export const isSavedVersionOutdated = (
  savedVersion: string,
  backendVersion: string,
): boolean => {
  return compareVersions(savedVersion, backendVersion) < 0;
};

export const isShowVersionBadge = (
  badgeVersion: string,
  version: string,
): boolean => {
  return compareVersions(badgeVersion, version, 2) >= 0;
};
